import { Injectable, Provider } from '@angular/core';
import { ProductAddToCartDialog } from 'projects/shared/lib/components/shared/product/add-to-cart-dialog/product-add-to-cart-dialog.model';
import { IProductAddToCartDialogService, IProductAddToCartDialogServiceToken } from 'projects/shared/lib/interfaces/services/dialogs/product-add-to-cart-dialog-service.abstract';

@Injectable({
  providedIn: 'root',
}) export class ProductAddToCartDialogService implements IProductAddToCartDialogService
{

  productAddToCartDialogShow(
    productAddToCartDialog: ProductAddToCartDialog
  )
  {
    return;
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ProductAddToCartDialogServiceProvider: Provider[] = [
  { provide: IProductAddToCartDialogServiceToken, useExisting: ProductAddToCartDialogService }
];